import React, { useState, useEffect } from "react";
import Template from "./InputCheckbox.jsx";

const CheckboxController = (props) => {
  const [value, setValue] = useState();

  useEffect(() => {
    setValue(props.value);
  }, []);

  const onChanges = (e) => {
    const { onChange } = props;
    const { checked: value } = e.target;

    e.target.value = value;
    setValue(value);

    if (onChange) {
      onChange(e);
    }
  };

  const handlers = {
    onChanges,
  };

  return <Template {...props} value={value} {...handlers} />;
};

export default CheckboxController;
